import React from "react";

export default function Product({
  product,
  dimensions: dimensionProps,
  selectedProduct,
  setSelectedProduct,
}) {
  const title = product.title;
  const compareAtPrice = product.variants[0].compare_at_price;
  const price = product.variants[0].price;
  const dimensions = title.match(/\b([0-9]|[1-9][0-9])\b/g);
  const height = dimensions[0];
  const width = dimensions[1];
  const badge = () => {
    if (width == 8 && height == 8) {
      return <div className="title-badge mini">Shelf Size</div>;
    } else if (width == 18 && height == 12) {
      return <div className="title-badge popular">Popular</div>;
    } else {
      return "";
    }
  };

  const isSelected = selectedProduct.id === product.id;

  function onClick() {
    dimensionProps.setCanHeight(height);
    dimensionProps.setCanWidth(width);
    setSelectedProduct(product);
  }
  return (
    <div
      className={isSelected ? "size-option selected" : "size-option"}
      onClick={onClick}
    >
      <span className="product-dimension">
        {height}" x {width}"
      </span>
      <span className="price">{price}</span>
      <span className="compare-at-price">{compareAtPrice}</span>
      {badge()}
    </div>
  );
}
